// ** api slice import
import { slices } from '../../app/slice';

// ** api routes for admin quiz management
const routes = {
  UPLOAD_TEMPLATE: '/quiz/template/upload',
  CREATE_TEMPLATE: '/quiz/template',
  GET_ACTIVE_TEMPLATE: '/quiz/template/active',
  GET_ALL_TEMPLATES: '/quiz/template/all',
  GET_TEMPLATE_BY_ID: '/quiz/template/:templateId',
  UPDATE_TEMPLATE_BY_ID: '/quiz/template/:templateId',
  ACTIVATE_TEMPLATE: '/quiz/template/:templateId/activate',
  DELETE_TEMPLATE_BY_ID: '/quiz/template/:templateId',
  RESTORE_TEMPLATE: '/quiz/template/:templateId/restore',
  SECTIONS_WITH_QUESTIONS: '/quiz/template/sections-with-questions',
};

// ** slice for admin quiz management
const quizTemplateApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    uploadTemplate: builder.mutation({
      query: data => ({
        url: routes.UPLOAD_TEMPLATE,
        method: 'POST',
        body: data,
      }),
    }),
    createTemplate: builder.mutation({
      query: data => ({
        url: routes.CREATE_TEMPLATE,
        method: 'POST',
        body: data,
      }),
    }),
    getActiveTemplate: builder.query({
      query: () => ({
        url: routes.GET_ACTIVE_TEMPLATE,
        method: 'GET',
      }),
    }),
    getAllTemplates: builder.query({
      query: query => ({
        url: routes.GET_ALL_TEMPLATES,
        method: 'GET',
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getTemplateById: builder.query({
      query: templateId => ({
        url: routes.GET_TEMPLATE_BY_ID.replace(':templateId', templateId),
        method: 'GET',
      }),
    }),
    updateTemplateById: builder.mutation({
      query: data => ({
        url: routes.UPDATE_TEMPLATE_BY_ID.replace(
          ':templateId',
          data.templateId
        ),
        method: 'PUT',
        body: data,
      }),
    }),
    activateTemplate: builder.mutation({
      query: templateId => ({
        url: routes.ACTIVATE_TEMPLATE.replace(':templateId', templateId),
        method: 'PUT',
      }),
    }),
    deleteTemplateById: builder.mutation({
      query: templateId => ({
        url: routes.DELETE_TEMPLATE_BY_ID.replace(':templateId', templateId),
        method: 'DELETE',
      }),
    }),
    restoreTemplate: builder.mutation({
      query: templateId => ({
        url: routes.RESTORE_TEMPLATE.replace(':templateId', templateId),
        method: 'PUT',
      }),
    }),
    getSectionsWithQuestions: builder.query({
      query: query => ({
        url: routes.SECTIONS_WITH_QUESTIONS,
        method: 'GET',
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const {
  useUploadTemplateMutation,
  useCreateTemplateMutation,
  useGetActiveTemplateQuery,
  useGetAllTemplatesQuery,
  useGetTemplateByIdQuery,
  useUpdateTemplateByIdMutation,
  useActivateTemplateMutation,
  useDeleteTemplateByIdMutation,
  useRestoreTemplateMutation,
  useGetSectionsWithQuestionsQuery,
} = quizTemplateApiSlice;
